module.exports = __webpack_public_path__ + "img/m_cer-title-two.d572395f.png";